import { render } from "./ControlListPropsCmp.vue?vue&type=template&id=3bc92d1c"
import script from "./ControlListPropsCmp.vue?vue&type=script&lang=js"
export * from "./ControlListPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__